// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* header */
.header {
    width: 100%;
    height: 65px;
    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.161);
    position: fixed;
    z-index: 23;
    top: 0;
    left: 0;
    background-color: #fff;
}

.header.dark {
    box-shadow: 0px 2px 3px rgba(255, 255, 255, 0.161);
    background-color: #121212;
    color: #fff;
}

.header-box {
    width: 100%;
    height: 100%;
    display: flex;
}

.header-left {
    width: 200px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-left a {
    display: flex;
    align-items: center;
    justify-content: center;
}

.header-left img {
    padding-top: 5px;
    width: 130px;
    cursor: pointer;
}

.header-right {
    width: calc(100% - 180px);
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}

.header-right-alert {
    position: absolute;
    left: 40px;
    width: 150px;
    height: 32px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
}

.header-right-alert.alert {
    background-color: #003577;
    color: #fff;
}

.header-right-alert.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #2f2f2f;
}

.header-right-alert.dark.alert {
    background-color: #003577;
    color: #fff;
}

.header-right-alert:hover {
    background-color: #003577;
    color: #fff;
}

.header-right-1 {
    position: absolute;
    width: auto;
    height: 100%;
    right: 20px;
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 15px;
    font-size: 14px;
}

.header-right-extension {
    width: 150px;
    height: 32px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    gap: 7px;
    cursor: pointer;
}

.header-right-extension.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #2f2f2f;
}

.header-right-extension svg {
    color: #6b6969;
}

.header-right-extension.dark svg {
    color: #a19f9f;
}

.header-right-extension:hover {
    background-color: #003577;
    color: #fff;
}

.header-right-extension:hover svg {
    color: #fff;
}

.header-right-logout {
    width: 80px;
    height: 32px;
    border: 1px solid #dbdbdb;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    cursor: pointer;
}

.header-right-logout.dark {
    background: #494848;
    color: #fff;
    border: 1px solid #2f2f2f;
}

.header-right-logout:hover {
    background-color: #003577;
    color: #fff;
}

.toggle-menu-sun-icon {
    color: #003577;
    font-size: 20px;
    cursor: pointer;
}

.toggle-menu-moon-icon {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin-right: 5px;
}




/* sidebar */
.sidebar-box-1 .cls-1,
.sidebar-box-1 .cls-2,
.sidebar-box-1 .cls-3 {
    fill: #707070;
}

.sidebar-box-1 .cls-1,
.sidebar-box-1 .cls-2,
.sidebar-box-1 .cls-3 {
    fill: #bdbdbd;
}

.sidebar-box-1 .cls-4 {
    fill: inherit;
}

.sidebar {
    width: 200px;
    height: 100vh;
    padding: 65px 10px 0;
    z-index: 22;
    background-color: rgba(246, 246, 246, 1);
    position: fixed;
    top: 0;
    left: 0;
    border-right: 1px solid rgba(246, 246, 246, 1);
}

.sidebar.dark {
    background: #242424;
    color: #fff;
    border-right: 1px solid #2f2f2f;
}

.sidebar-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 10px);
    margin: 0 auto;
    font-size: 14px;
    color: gray;
    cursor: pointer;
}

.sidebar-box {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.sidebar-box-1 {
    width: 100%;
    padding: 0 0 0 20px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 15px;
    cursor: pointer;
    color: #535252;
    border-radius: 5px;
}

.sidebar-box-1.dark {
    color: #bdbdbd;
}

.sidebar-box-1 svg {
    width: 22px;
}

.sidebar-box-1.on {
    color: #003577;
    transition: all 0.2s;
    background-color: #fff;
}

.sidebar-box-1.on.dark {
    background: #494848;
}

.sidebar-box-1.on .cls-1,
.sidebar-box-1.on .cls-3 {
    fill: #003577;
}

.sidebar-box-1.on .cls-4 {
    fill: #fff;
}

.sidebar-box-1:hover {
    color: #003577;
    transition: all 0.2s;
    background-color: #fff;
}

.sidebar-box-1.dark:hover {
    background: #494848;
}

.sidebar-box-1:hover .cls-1,
.sidebar-box-1:hover .cls-3 {
    fill: #003577;
}

.sidebar-box-1:hover .cls-4 {
    fill: #fff;
}

.sidebar-box-2 {
    width: 100%;
    height: auto;
    gap: 15px;
}

.sidebar-box-1-1 {
    font-size: 15px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.sidebar-box-1-2 {
    font-size: 13px;
    color: #707070;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    width: 100%;
    margin-top: 5px;
    gap: 2px;
    font-weight: bold;
}

.sidebar-box-1-2 div {
    /* width: calc(100% - 65px); */
    height: 30px;
    cursor: pointer;
    color: #707070;
    padding-left: 27px;
    display: flex;
    align-items: center;
}

.sidebar-box-1-2 div:hover {
    transition: all 0.2s;
    background-color: #fff;
    border-radius: 5px;
    color: #003577;
}

.sidebar-box-1-2.dark div:hover {
    background-color: #494848;
}

.sidebar-box-1-2 div.on {
    transition: all 0.2s;
    background-color: #fff;
    border-radius: 5px;
    color: #003577;
}

.sidebar-box-1-2.dark div.on {
    background-color: #494848;
}




/* footer */
.footer {
    width: 100%;
    height: 35px;
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 1px solid #dcdee0;
    z-index: 2;
    background-color: #fff;
}

.footer.dark {
    background-color: #121212;
    color: #fff;
    border: 1px solid #2f2f2f;
}

.footer-box {
    width: 100%;
    padding: 0 20px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.footer-box-1 {
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/Nav/nav.css"],"names":[],"mappings":"AAAA,WAAW;AACX;IACI,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,eAAe;IACf,WAAW;IACX,MAAM;IACN,OAAO;IACP,sBAAsB;AAC1B;;AAEA;IACI,kDAAkD;IAClD,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;;;;AAKA,YAAY;AACZ;;;IAGI,aAAa;AACjB;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,WAAW;IACX,wCAAwC;IACxC,eAAe;IACf,MAAM;IACN,OAAO;IACP,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;IACxB,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;;;;AAKA,WAAW;AACX;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,SAAS;IACT,OAAO;IACP,6BAA6B;IAC7B,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB","sourcesContent":["/* header */\r\n.header {\r\n    width: 100%;\r\n    height: 65px;\r\n    box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.161);\r\n    position: fixed;\r\n    z-index: 23;\r\n    top: 0;\r\n    left: 0;\r\n    background-color: #fff;\r\n}\r\n\r\n.header.dark {\r\n    box-shadow: 0px 2px 3px rgba(255, 255, 255, 0.161);\r\n    background-color: #121212;\r\n    color: #fff;\r\n}\r\n\r\n.header-box {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: flex;\r\n}\r\n\r\n.header-left {\r\n    width: 200px;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.header-left a {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.header-left img {\r\n    padding-top: 5px;\r\n    width: 130px;\r\n    cursor: pointer;\r\n}\r\n\r\n.header-right {\r\n    width: calc(100% - 180px);\r\n    height: 100%;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.header-right-alert {\r\n    position: absolute;\r\n    left: 40px;\r\n    width: 150px;\r\n    height: 32px;\r\n    border: 1px solid #dbdbdb;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n}\r\n\r\n.header-right-alert.alert {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.header-right-alert.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #2f2f2f;\r\n}\r\n\r\n.header-right-alert.dark.alert {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.header-right-alert:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.header-right-1 {\r\n    position: absolute;\r\n    width: auto;\r\n    height: 100%;\r\n    right: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: end;\r\n    gap: 15px;\r\n    font-size: 14px;\r\n}\r\n\r\n.header-right-extension {\r\n    width: 150px;\r\n    height: 32px;\r\n    border: 1px solid #dbdbdb;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 14px;\r\n    gap: 7px;\r\n    cursor: pointer;\r\n}\r\n\r\n.header-right-extension.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #2f2f2f;\r\n}\r\n\r\n.header-right-extension svg {\r\n    color: #6b6969;\r\n}\r\n\r\n.header-right-extension.dark svg {\r\n    color: #a19f9f;\r\n}\r\n\r\n.header-right-extension:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.header-right-extension:hover svg {\r\n    color: #fff;\r\n}\r\n\r\n.header-right-logout {\r\n    width: 80px;\r\n    height: 32px;\r\n    border: 1px solid #dbdbdb;\r\n    border-radius: 5px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n}\r\n\r\n.header-right-logout.dark {\r\n    background: #494848;\r\n    color: #fff;\r\n    border: 1px solid #2f2f2f;\r\n}\r\n\r\n.header-right-logout:hover {\r\n    background-color: #003577;\r\n    color: #fff;\r\n}\r\n\r\n.toggle-menu-sun-icon {\r\n    color: #003577;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n}\r\n\r\n.toggle-menu-moon-icon {\r\n    color: #fff;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n    margin-right: 5px;\r\n}\r\n\r\n\r\n\r\n\r\n/* sidebar */\r\n.sidebar-box-1 .cls-1,\r\n.sidebar-box-1 .cls-2,\r\n.sidebar-box-1 .cls-3 {\r\n    fill: #707070;\r\n}\r\n\r\n.sidebar-box-1 .cls-1,\r\n.sidebar-box-1 .cls-2,\r\n.sidebar-box-1 .cls-3 {\r\n    fill: #bdbdbd;\r\n}\r\n\r\n.sidebar-box-1 .cls-4 {\r\n    fill: inherit;\r\n}\r\n\r\n.sidebar {\r\n    width: 200px;\r\n    height: 100vh;\r\n    padding: 65px 10px 0;\r\n    z-index: 22;\r\n    background-color: rgba(246, 246, 246, 1);\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    border-right: 1px solid rgba(246, 246, 246, 1);\r\n}\r\n\r\n.sidebar.dark {\r\n    background: #242424;\r\n    color: #fff;\r\n    border-right: 1px solid #2f2f2f;\r\n}\r\n\r\n.sidebar-title {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: calc(100% - 10px);\r\n    margin: 0 auto;\r\n    font-size: 14px;\r\n    color: gray;\r\n    cursor: pointer;\r\n}\r\n\r\n.sidebar-box {\r\n    padding-top: 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 7px;\r\n}\r\n\r\n.sidebar-box-1 {\r\n    width: 100%;\r\n    padding: 0 0 0 20px;\r\n    height: 30px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 15px;\r\n    cursor: pointer;\r\n    color: #535252;\r\n    border-radius: 5px;\r\n}\r\n\r\n.sidebar-box-1.dark {\r\n    color: #bdbdbd;\r\n}\r\n\r\n.sidebar-box-1 svg {\r\n    width: 22px;\r\n}\r\n\r\n.sidebar-box-1.on {\r\n    color: #003577;\r\n    transition: all 0.2s;\r\n    background-color: #fff;\r\n}\r\n\r\n.sidebar-box-1.on.dark {\r\n    background: #494848;\r\n}\r\n\r\n.sidebar-box-1.on .cls-1,\r\n.sidebar-box-1.on .cls-3 {\r\n    fill: #003577;\r\n}\r\n\r\n.sidebar-box-1.on .cls-4 {\r\n    fill: #fff;\r\n}\r\n\r\n.sidebar-box-1:hover {\r\n    color: #003577;\r\n    transition: all 0.2s;\r\n    background-color: #fff;\r\n}\r\n\r\n.sidebar-box-1.dark:hover {\r\n    background: #494848;\r\n}\r\n\r\n.sidebar-box-1:hover .cls-1,\r\n.sidebar-box-1:hover .cls-3 {\r\n    fill: #003577;\r\n}\r\n\r\n.sidebar-box-1:hover .cls-4 {\r\n    fill: #fff;\r\n}\r\n\r\n.sidebar-box-2 {\r\n    width: 100%;\r\n    height: auto;\r\n    gap: 15px;\r\n}\r\n\r\n.sidebar-box-1-1 {\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n\r\n.sidebar-box-1-2 {\r\n    font-size: 13px;\r\n    color: #707070;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    text-align: left;\r\n    width: 100%;\r\n    margin-top: 5px;\r\n    gap: 2px;\r\n    font-weight: bold;\r\n}\r\n\r\n.sidebar-box-1-2 div {\r\n    /* width: calc(100% - 65px); */\r\n    height: 30px;\r\n    cursor: pointer;\r\n    color: #707070;\r\n    padding-left: 27px;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.sidebar-box-1-2 div:hover {\r\n    transition: all 0.2s;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    color: #003577;\r\n}\r\n\r\n.sidebar-box-1-2.dark div:hover {\r\n    background-color: #494848;\r\n}\r\n\r\n.sidebar-box-1-2 div.on {\r\n    transition: all 0.2s;\r\n    background-color: #fff;\r\n    border-radius: 5px;\r\n    color: #003577;\r\n}\r\n\r\n.sidebar-box-1-2.dark div.on {\r\n    background-color: #494848;\r\n}\r\n\r\n\r\n\r\n\r\n/* footer */\r\n.footer {\r\n    width: 100%;\r\n    height: 35px;\r\n    position: fixed;\r\n    bottom: 0;\r\n    left: 0;\r\n    border-top: 1px solid #dcdee0;\r\n    z-index: 2;\r\n    background-color: #fff;\r\n}\r\n\r\n.footer.dark {\r\n    background-color: #121212;\r\n    color: #fff;\r\n    border: 1px solid #2f2f2f;\r\n}\r\n\r\n.footer-box {\r\n    width: 100%;\r\n    padding: 0 20px;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.footer-box-1 {\r\n    font-size: 12px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
